import cookies from 'js-cookie';

type ApiFetchInit = Omit<RequestInit, 'headers'> & { headers?: Record<string, string> };

// Read the cookie directly: useUser() would open a useCookie watcher per call outside any effect scope.
function sessionJwt(): string | undefined {
  const raw = cookies.get('ft-ss-auth');
  if (!raw) {
    return undefined;
  }

  try {
    const token = JSON.parse(raw)?.JwtToken;
    return typeof token === 'string' && token ? token : undefined;
  } catch {
    return undefined;
  }
}

export function playerAuthHeaders(headers: Record<string, string> = {}): Record<string, string> {
  const jwt = sessionJwt();
  if (!jwt) {
    return { ...headers };
  }

  return { ...headers, Authorization: `Bearer ${jwt}` };
}

export default function apiFetch(path: string, init: ApiFetchInit = {}): Promise<Response> {
  return fetch(path, { ...init, headers: playerAuthHeaders(init.headers) });
}
